import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=2fb3c350&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=2fb3c350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb3c350",
  null
  
)

export default component.exports